import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, FolderOpen, LogOut, ArrowLeft } from "lucide-react";

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const nav = [
    { to: "/portal", label: "Dashboard", icon: LayoutDashboard, exact: true },
    { to: "/portal/library", label: "Document Library", icon: FolderOpen },
  ];

  const isActive = (n) => (n.exact ? pathname === n.to : pathname.startsWith(n.to));

  return (
    <div className="min-h-screen flex">
      <aside className="w-64 border-r border-border bg-white hidden md:flex flex-col">
        <div className="h-16 flex items-center px-6 border-b border-border">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-primary flex items-center justify-center">
              <span className="font-heading font-black text-white">C</span>
            </div>
            <span className="font-heading font-bold tracking-tight">Centennial</span>
          </Link>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => {
            const Icon = n.icon;
            return (
              <Link key={n.to} to={n.to} data-testid={`portal-nav-${n.label.split(" ")[0].toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive(n) ? "bg-primary text-white" : "text-foreground/80 hover:bg-secondary"
                }`}>
                <Icon className="w-4 h-4" /> {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-border space-y-1">
          <Link to="/" className="flex items-center gap-3 px-4 py-2.5 text-sm text-muted-foreground hover:bg-secondary">
            <ArrowLeft className="w-4 h-4" /> Back to site
          </Link>
          <button onClick={() => { logout(); navigate("/"); }} data-testid="portal-logout"
            className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-accent hover:bg-accent/5">
            <LogOut className="w-4 h-4" /> Log out
          </button>
        </div>
      </aside>

      <div className="flex-1 bg-secondary/40 min-w-0">
        <header className="h-16 bg-white border-b border-border flex items-center justify-between px-6">
          <div className="font-heading font-semibold">My Portal</div>
          <div className="text-sm text-muted-foreground">{user?.name}</div>
        </header>
        <main className="p-6 lg:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
